'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndDrug2 } from '../../Entities/Ind/IndDrug2';
import { IndDrug2Collection } from '../../Collections/Ind/IndDrug2Collection';

export class IndDrug2Repository extends CoreRepository {
  /*public getIndDrug2(individualId: number, options: object = {}) {
      if (!options) {
        options = {};
      }
  
      return this.webAPI.getInd(individualId, options)
        .then(response => {
          let user = new Ind();
          user.hydrate(response);
  
          return user;
        });
  
    }
  
    public getInds(options: object = {}, criteria: object = null) {
      if (!options) {
        options = {};
      }
  
      if (criteria) {
        options['criteria'] = criteria;
      }
  
      return this.webAPI.getInds(options)
        .then(response => {
          let collection = new IndCollection();
  
          response.data.forEach(collectionItemData => {
            let collectionItem = new Ind();
            collectionItem.hydrate(collectionItemData);
  
            collection.addItem(collectionItem);
          });
  
          collection.setOffset(response.offset);
          collection.setLimit(response.limit);
          collection.setTotal(response.total);
  
          return collection;
        });
  
    }
  
    
  */

  public createIndDrug2(indId: number, payload: any[]) {
    return this.webAPI.createIndDrug2(indId, payload).then((response) => {
      const indDrug2 = new IndDrug2();
      indDrug2.hydrate(response);

      return indDrug2;
    });
  }

  public removeIndDrug2(indId: number, indDrug2Id: number) {
    return this.webAPI.removeIndDrug2(indId, indDrug2Id).then((response) => {
      return response;
    });
  }

  public updateIndDrug2(indId: number, indDrug2Id: number, payload: any[]) {
    return this.webAPI.updateIndDrug2(indId, indDrug2Id, payload).then((response) => {
      return response;
    });
  }

  public moveIndDrug2(individualId: number, individualDrug2Id: number, payload: any[]) {
    return this.webAPI.moveIndDrug2(individualId, individualDrug2Id, payload).then((response) => {
      return response;
    });
  }
}
